import { render } from "./TvmBbTradeValue.vue?vue&type=template&id=06153822&scoped=true"
import script from "./TvmBbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmBbTradeValue.vue?vue&type=script&lang=js"

import "./TvmBbTradeValue.vue?vue&type=style&index=0&id=06153822&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06153822"],['__file',"src/Components/ChatWidget/TvmSellUsYourCar/TvmBbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06153822"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06153822', __exports__)) {
    api.reload('06153822', __exports__)
  }
  
  module.hot.accept("./TvmBbTradeValue.vue?vue&type=template&id=06153822&scoped=true", () => {
    api.rerender('06153822', render)
  })

}


export default __exports__